import { Grid } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { PieChart, Pie,  Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

interface DepartmentGraphProps {
  departmentsChart: any;
  viewRolePermission: boolean;
}
export const DepartmentSalesReport: FunctionComponent<DepartmentGraphProps> = ({
  departmentsChart,
  viewRolePermission
}) => {

  const changedArray =
    departmentsChart.map((i: any) => {
      return { name: i.name, value: parseFloat(i.float_departmenttotal) }
    })
    const COLORS = ["rgb(51 70 114)", "rgb(34, 84, 135)", "rgb(59, 103, 149)", "rgb(84, 122, 162)", "rgb(108, 141, 175)", 
    "rgb(133, 160, 189)", "rgb(157, 179, 202)", "rgb(182, 198, 215)", "rgb(206, 217, 228)"]

  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
  }: any) => {

    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  if (departmentsChart.length === 0) {
    return <h2>No data to show report!</h2>
  } else {
    return (
      <Grid container justify="center">
        <Grid item>
          <ResponsiveContainer width={400} height={430}>
            <PieChart>
              <Pie
                data={changedArray}
                cx={200}
                cy={150}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={155}
                fill="#8884d8"
                dataKey="value"
              >
                {changedArray.map((entry: any, index: any) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Legend wrapperStyle={{
                // position: "absolute",
                width: "428px",
                height: "109px",
                // left: "5px",
                // bottom: "5px"
              }}/>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Grid>
      </Grid>
    );
  }
};



